import React from "react";

export default function Hero() {
  return (
    <div>
      <div className="h-screen bg-[#F5FCFF] flex">
        <div className="flex flex-wrap justify-center md:flex-nowrap md:items-center mx-6 md:mx-20">
          <div className="w-full md:w-1/2 flex items-center">
            <div className="flex-col">
              <p className="font-semibold text-xl">hi im Hijriyanto Wahyudi</p>
              <h1 className="font-bold text-3xl md:text-4xl capitalize">
                I am <span className="text-[#5E3BEE]">fullstack developer</span>{" "}
                and student
              </h1>
              <div className="mt-4">
                <button className="bg-[#5E3BEE] text-white px-4 py-2 rounded-e-full">
                  Contact Me Here !
                </button>
              </div>
              <div className="mt-4 ml-2 flex gap-3">
                <a href="https://api.whatsapp.com/send?phone=6283121065540" rel="noreferrer" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#25D366"
                  >
                    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                  </svg>
                </a>

                <a href="https://www.facebook.com/profile.php?id=100073641038027&mibextid=ZbWKwL" rel="noreferrer" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#1877F2"
                  >
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-3 7h-1.924c-.615 0-1.076.252-1.076.889v1.111h3l-.238 3h-2.762v8h-3v-8h-2v-3h2v-1.923c0-2.022 1.064-3.077 3.461-3.077h2.539v3z" />
                  </svg>
                </a>

                <a href="https://www.instagram.com/yuu.jsx/" rel="noreferrer" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 28.87 28.87"
                    id="instagram"
                    width="24"
                  >
                    <defs>
                      <linearGradient
                        id="a"
                        x1="-1.84"
                        x2="32.16"
                        y1="30.47"
                        y2="-3.03"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" stop-color="#fed576"></stop>
                        <stop offset=".26" stop-color="#f47133"></stop>
                        <stop offset=".61" stop-color="#bc3081"></stop>
                        <stop offset="1" stop-color="#4c63d2"></stop>
                      </linearGradient>
                    </defs>
                    <g data-name="Layer 2">
                      <g data-name="Layer 1">
                        <rect
                          width="28.87"
                          height="28.87"
                          fill="url(#a)"
                          rx="6.48"
                          ry="6.48"
                        ></rect>
                        <g data-name="<Group>">
                          <path
                            fill="#fff"
                            d="M10 5h9c.2.1.5.1.7.2a4.78 4.78 0 0 1 3.8 3.3 8 8 0 0 1 .3 1.5v8.8a6.94 6.94 0 0 1-1.2 3.1 5.51 5.51 0 0 1-4.5 1.9h-7.5a5.49 5.49 0 0 1-3.7-1.2A5.51 5.51 0 0 1 5 18.14v-7a7.57 7.57 0 0 1 .1-1.5 4.9 4.9 0 0 1 3.8-4.3zm-3.1 9.5v3.9a3.42 3.42 0 0 0 3.7 3.7q3.9.15 7.8 0c2.3 0 3.6-1.4 3.7-3.7q.15-3.9 0-7.8a3.52 3.52 0 0 0-3.7-3.7q-3.9-.15-7.8 0a3.42 3.42 0 0 0-3.7 3.7z"
                            data-name="<Compound Path>"
                          ></path>
                          <path
                            fill="#fff"
                            d="M9.64 14.54a4.91 4.91 0 0 1 4.9-4.9 5 5 0 0 1 4.9 4.9 4.91 4.91 0 0 1-4.9 4.9 5 5 0 0 1-4.9-4.9zm4.9-3.1a3.05 3.05 0 1 0 3 3 3 3 0 0 0-3-3z"
                            data-name="<Compound Path>"
                          ></path>
                          <path
                            fill="#fff"
                            d="M18.34 9.44a1.16 1.16 0 0 1 1.2-1.2 1.29 1.29 0 0 1 1.2 1.2 1.2 1.2 0 0 1-2.4 0z"
                            data-name="<Path>"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2 flex items-center justify-center">
            <img
              src="./images/profile.jpg"
              alt=""
              className="max-w-full lg:w-1/2 rounded-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
